"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getSelectableOption = function () {
  var _options$identifier$i, _options$identifier;
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let identifier = arguments.length > 1 ? arguments[1] : undefined;
  const items = (_options$identifier$i = options === null || options === void 0 || (_options$identifier = options[identifier]) === null || _options$identifier === void 0 ? void 0 : _options$identifier.items) !== null && _options$identifier$i !== void 0 ? _options$identifier$i : [];
  return items === null || items === void 0 ? void 0 : items.find(item => item.selectable);
};
var _default = exports.default = getSelectableOption;